<template>
  <div class="">
    <el-form ref="merchantChangeForm" :model="merchantChangeForm" :rules="merchantChangeFormRules" label-width="130px">
      <el-form-item label="商户ID" v-if="pageType === 'change'" >
        <el-input clearable v-model="merchantChangeForm.id" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="商户名称" prop="name">
        <el-input clearable v-model="merchantChangeForm.name" prop="name"></el-input>
      </el-form-item>
      <el-form-item label="商户联系人" prop="contactPerson">
        <el-input clearable v-model="merchantChangeForm.contactPerson"></el-input>
      </el-form-item>
      <el-form-item label="联系人电话" prop="contactNumber">
        <el-input clearable v-model="merchantChangeForm.contactNumber"></el-input>
      </el-form-item>
      <el-form-item label="营业执照">
        <el-upload
          class="avatar-uploader"
          action="aa"
          :show-file-list="false"
          :before-upload="addLicenseImage">
          <img v-if="licenseImageUrl" :src="licenseImageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="法人身份证">
        <el-upload
          class="avatar-uploader"
          action="aa"
          :show-file-list="false"
          :before-upload="addCardImage">
          <img v-if="cardImageUrl" :src="cardImageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="银行卡" prop="bankAccount">
        <el-input clearable v-model="merchantChangeForm.bankAccount"></el-input>
      </el-form-item>
      <el-form-item label="开户行" prop="bankBranch">
        <el-input clearable v-model="merchantChangeForm.bankBranch"></el-input>
      </el-form-item>
      <el-form-item label="提价比例" prop="raisePriceProportion">
        <el-input clearable v-model="merchantChangeForm.raisePriceProportion"></el-input>
      </el-form-item>
      <el-form-item label="是否询价下单商户" prop="queryOrderFlag">
         <el-radio v-model="merchantChangeForm.queryOrderFlag" label="0" >否</el-radio>
         <el-radio v-model="merchantChangeForm.queryOrderFlag" label="1">是</el-radio>
      </el-form-item>
        <el-form-item label="是否快速审单商户" prop="quickCheckOrderFlag">
         <el-radio v-model="merchantChangeForm.quickCheckOrderFlag" label="0" >否</el-radio>
         <el-radio v-model="merchantChangeForm.quickCheckOrderFlag" label="1">是</el-radio>
      </el-form-item>
      <el-form-item label="是否展示多家回收价" prop="showMutilationPrice">
         <el-radio v-model="merchantChangeForm.showMutilationPrice" :label="0" >否</el-radio>
         <el-radio v-model="merchantChangeForm.showMutilationPrice" :label="1">是</el-radio>
      </el-form-item>
      <el-form-item label="展示预估价" prop="displayValuationPriceFlag">
         <el-radio v-model="merchantChangeForm.displayValuationPriceFlag" :label="0" >显示</el-radio>
         <el-radio v-model="merchantChangeForm.displayValuationPriceFlag" :label="1">不显示</el-radio>
      </el-form-item>
      <el-form-item label="增值方式" prop="priceIncreaseWay">
         <el-radio v-model="merchantChangeForm.priceIncreaseWay" :label="0" >百分比</el-radio>
         <el-radio v-model="merchantChangeForm.priceIncreaseWay" :label="1">固定金额</el-radio>
      </el-form-item>
      <el-form-item label="退款方式" prop="refundWay">
         <el-radio v-model="merchantChangeForm.refundWay" :label="0" >回收款和店奖分开</el-radio>
         <el-radio v-model="merchantChangeForm.refundWay" :label="1">回收款和店奖合并</el-radio>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="newMerchant('merchantChangeForm')">确定</el-button>
        <el-button v-if="pageType === 'change'" @click="$router.go(-1)">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
let validateIsFloat = (rule, value, callback) => {
  console.log(value);
  if (!/^([1-9][0-9]+|[0-9])(\.[0-9]+)?$/g.test(value)) {
    callback(new Error('提成比例必须为数字值'));
  } else if (value > 1 || value < 0) {
    callback(new Error('提成比例为大于0小于1的数值'));
  } else {
    callback();
  }
};
export default {
  components:{},
  props:{},
  data(){
    return {

      // pageType 默认是修改，获取不到对象改为新建
      pageType: 'change',

      // 修改和新建弹窗数据
      licenseImageUrl: '',
      cardImageUrl: '',
      
      merchantChangeForm: {
        id: null,
        name: null,
        contactPerson: null,
        contactNumber: null,
        icense: null,
        card: null,
        bankAccount: null,
        bankBranch: null,
        raisePriceProportion: null,
        quickCheckOrderFlag: "0",
        showMutilationPrice: 0,
        displayValuationPriceFlag:0,
        priceIncreaseWay:0,
        refundWay:0,
        queryOrderFlag: "1"
      },

      merchantChangeFormRules: {
        name: [
          { required: true, message: '请填写商户名称', trigger: 'change' }
        ],
       
        contactPerson: [
          { required: true, message: '请填写联系人', trigger: 'change' }
        ],
        contactNumber: [
          { required: true, message: '请填写联系人电话', trigger: 'change' }
        ],
        bankAccount: [
          { required: true, message: '请填写银行账号', trigger: 'change' },
          // { type: 'number', message: '银行账号必须为数字值'}
        ],
        bankBranch: [
          { required: true, message: '请填写开户行', trigger: 'change' }
        ],
      }
    }
  },
  watch:{},
  computed:{},
  methods:{
    // 添加图片附件
    addCardImage(file) {
      this.merchantChangeForm.card = file
      this.cardImageUrl = this.upImageD(file)
      return false
    },

    // 添加图片附件
    addLicenseImage(file) {
      this.merchantChangeForm.icense = file
      this.licenseImageUrl = this.upImageD(file)
      return false
    },

    // 图片添加处理
    upImageD(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return false
      }
      let  windowURL = window.URL || window.webkitURL;
      return windowURL.createObjectURL(file)
    },

     // 表单验证
    formvalidate(formName, cb){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          cb()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     },



    // 新建商户
    newMerchant(formName) {
      let self = this;
      self.formvalidate(formName, () => {

        let formData = new FormData()

        for(let i in this.merchantChangeForm) {
          if(this.merchantChangeForm[i]) {
            if(i === 'id') {
              formData.append('merchantId', this.merchantChangeForm[i])
            } else  if(i === 'icense') {
              formData.append('1', this.merchantChangeForm[i])
            } else if(i === 'card') {
              formData.append('2', this.merchantChangeForm[i])
            } else{
              // params[i] = this.merchantChangeForm[i]
              formData.append(i, this.merchantChangeForm[i])
            }
          }
        }
        if(formData.get("quickCheckOrderFlag") ==="0" && formData.get("queryOrderFlag") ==="0"){
            self.$message("请保证快速审单或询价下单，至少一个类型选项为是，否则商户将无法下单！")
            return;
        }

        if(self.pageType === 'change') {
           formData.append('showMutilationPrice', this.merchantChangeForm.showMutilationPrice)
           formData.append('displayValuationPriceFlag', this.merchantChangeForm.displayValuationPriceFlag)
           formData.append('priceIncreaseWay', this.merchantChangeForm.priceIncreaseWay)
           formData.append('refundWay', this.merchantChangeForm.refundWay)
          self.$api.changeMerchant(this.merchantChangeForm.id, formData).then(res => {
            if(res.code === 200) {
              this.$router.go(-1)
            }
          })

        } else {

          self.$api.addMerchant(formData).then(res => {
            if(res.code === 200) {
              this.$router.push({path: '/index/merchant/merchant'})
            }
          })
        }
      })
    },



  },
  created(){},
  mounted(){
    let self = this;
    let params = this.$route.query
    

    if(JSON.stringify(params)=="{}"){
      self.pageType = 'new'
      document.title = '新建商户'
    } else {
      document.title = '修改商户'

      self.$api.getMerchantDetail(params.id).then(res => {

        let paramKey = {
          id: 1,
          name: 1,
          contactPerson: 1,
          contactNumber: 1,
          icense: 1,
          card: 1,
          bankAccount: 1,
          bankBranch: 1,
          commission: 1,
          merchantCommission: 1,
          raisePriceProportion: 1,
          singleQuota:1,
          totalQuota:1,
          quickCheckOrderFlag:"0",
          showMutilationPrice: res.data.showMutilationPrice,
          displayValuationPriceFlag:res.data.displayValuationPriceFlag,
          priceIncreaseWay:res.data.priceIncreaseWay,
          refundWay:res.data.refundWay,
          queryOrderFlag:"1"
        }


        if(res.code === 200) {
          for(let i in res.data) {
            if(i === 'merchantAttachments') {
              if(res.data['merchantAttachments'][0].type === 1) {
                self.licenseImageUrl = res.data['merchantAttachments'][0].url
                self.cardImageUrl = res.data['merchantAttachments'][1].url
              } else {
                self.licenseImageUrl = res.data['merchantAttachments'][1].url
                self.cardImageUrl = res.data['merchantAttachments'][0].url
              }
            } else if(i === 'commission') {//|| i === 'merchantCommission'
              if(res.data[i]) this.merchantChangeForm[i] = parseFloat(res.data[i], 10)

              
              // 排除多余的数据
            } else if(paramKey[i]){
              this.merchantChangeForm[i] = res.data[i]
            }
          }
          console.log(this.merchantChangeForm);
        }
      })



    }
  }
}
</script>
<style lang="less" scoped>
  .avatar-uploader-icon {
    background-color: #fff;
    border-radius: 10px;
    border: 1px dashed #ccc;
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
</style>